import './TextArea.module.scss';

const TextArea = ({ value, onChange }) => {
  return <textarea name='textArea' value={value} onChange={event => onChange(event.target.value)} />;
};

export default TextArea;
